/**
 * `/invoices` search params: the month (shared month screens), plus the links into the screen —
 * Finance opens `?month=&project=` (that project's drawer), Documents `?open=<invoiceId>`.
 */
import { validateMonthSearch } from '../../lib/months';
import type { MonthSearch } from '../../lib/months';

export interface InvoicesSearch extends MonthSearch {
  readonly project?: string;
  readonly open?: string;
}

const textParam = (value: unknown): string | undefined => (typeof value === 'string' && value.trim() ? value : undefined);

export function validateInvoicesSearch(search: Record<string, unknown>): InvoicesSearch {
  const project = textParam(search.project);
  const open = textParam(search.open);
  return { ...validateMonthSearch(search), ...(project ? { project } : {}), ...(open ? { open } : {}) };
}
